// extracted by mini-css-extract-plugin
export var alignCenter = "_ar-d";
export var bannerShown = "_ar-6";
export var buttonContent = "_ar-0";
export var cardList = "_ar-1";
export var centerContent = "_ar-2";
export var chevron = "_ar-3";
export var closePanelButton = "_ar-k";
export var conversationContextContainer = "_ar-l";
export var conversationDetailContainer = "_ar-4";
export var detailWrapper = "_ar-7";
export var dropdownButton = "_ar-e";
export var dropdownTitle = "_ar-9";
export var fullHeight = "_ar-5";
export var hidden = "_ar-a";
export var icon = "_ar-b";
export var mergeSuggestionWrapper = "_ar-m";
export var panel = "_ar-i";
export var portalButtonsWrapper = "_ar-c";
export var right = "_ar-j";
export var tableSummaryContainer = "_ar-8";
export var tableSummaryHeader = "_ar-g";
export var threeDotsButton = "_ar-f";
export var wide = "_ar-h";